/* eslint-disable dot-notation */
/* eslint-disable no-use-before-define */
import { document } from "browser-monads";
import PropTypes from "prop-types";
import React, { useEffect, useState, useCallback } from "react";
import {
  annualTurnOverOptions,
  gstValueOptions,
} from "../../constants/contact-us";
import { COMMON_ADMIN_URL, MERCHANT_HELP_URL } from "../../constants/env";
import Image from "../Image";
import Select from "../Input/Select/Select";

const HeroSectionForm = ({
  formUtmFormIntergration,
  chooseProductValue,
  doYouWantBusinessEmailRestrictionPaidads,
  hero3formFormFieldsCustomization,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [designation, setDesignation] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [message, setMessage] = useState("");
  const [sourceAction, setSourceAction] = useState("");
  const [actionType, setActionType] = useState("");
  const [annualTurnover, setAnnualTurnoverYourself] = useState(
    annualTurnOverOptions,
  );
  const [gstValueOption, setGstValueOption] = useState(gstValueOptions);

  // validation part
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [nameValidate, setNameValidate] = useState(false);
  const [emailValidate, setEmailValidate] = useState(false);
  const [phoneValidate, setPhoneValidate] = useState(false);
  const [messageValidate, setMessageValidate] = useState(false);
  const [designationValidate, setDesignationValidate] = useState(false);
  const [websiteURLValidate, setWebsiteURLValidate] = useState(false);
  const [corporateEmailValidate, setCorporateEmailValidate] = useState(true);

  const [annualTurnoverValidation, setAnnualTurnoverfValidation] = useState(
    false,
  );
  const [gstValueValidation, setGstValuevalidation] = useState(false);
  const [showFormError, setShowFormError] = useState(false);
  const [annualTurnValue, setAnnualTurnOver] = useState("");
  const [gstValue, setGstValue] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  // UTM Action
  const UTM_PARAMS = {
    utm_source: "utm_source",
    utm_medium: "utm_medium",
    utm_campaign: "utm_campaign",
    utm_term: "utm_term",
    utm_content: "utm_content",
    gclid: "gclid",
    fbclid: "fbclid",
  };
  const UTM_CAMPAIGN_URL = "__gtm_campaign_url";
  const getCookie = (cookieName) => {
    const CookieNames = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document?.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(CookieNames) === 0) {
        return c.substring(CookieNames.length, c.length);
      }
    }
    return "";
  };

  const checkCorporateEmail = (val) => {
    fetch(`${COMMON_ADMIN_URL}/email/domain-check?email=${val}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCorporateEmailValidate(data);
        validateForm();
      })
      .catch(() => {
        setCorporateEmailValidate(false);
        validateForm();
      });
  };

  const getParam = (url, param) => {
    const match = RegExp(`[?&]${param}=([^&]*)`).exec(url);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  };

  function getUTMObject() {
    const utmCookieValue = getCookie(UTM_CAMPAIGN_URL);
    const utmObject = {};
    Object.keys(UTM_PARAMS).forEach((key) => {
      const value = getParam(utmCookieValue, key);
      if (value) utmObject[UTM_PARAMS[key]] = value;
    });
    return utmObject;
  }

  // get UTM params from cookies
  const metadata = getUTMObject();

  const validateEmail = (val) => {
    if (!hero3formFormFieldsCustomization.includes("work_email")) return true;
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return val.toLowerCase().match(validRegex);
  };

  const validateName = (val) => {
    if (!hero3formFormFieldsCustomization.includes("Name")) return true;
    return val.length > 0;
  };

  const validateDesignation = (val) => {
    if (!hero3formFormFieldsCustomization.includes("Designation")) return true;
    return val.length > 0;
  };

  const validateWebsiteURL = (val) => {
    if (!hero3formFormFieldsCustomization.includes("website_URL")) return true;
    return val.length > 0;
  };

  const validatePhone = (val) => {
    if (!hero3formFormFieldsCustomization.includes("phone_number")) return true;
    return val.length === 10 && Number.isInteger(Number(val));
  };

  const validateAnnualTurnover = (val) => {
    if (!hero3formFormFieldsCustomization.includes("Annual_turnover"))
      return true;
    return val && val.value && val.value.length > 0;
  };

  const validateGSTValue = (val) => {
    if (!hero3formFormFieldsCustomization.includes("Gst_Yes_No")) return true;
    return val && val.value && val.value.length > 0;
  };

  const validateMessage = (val) => {
    if (!hero3formFormFieldsCustomization.includes("Message")) return true;
    return val.length > 0;
  };

  const validateForm = useCallback(() => {
    const isValid =
      validateName(name) &&
      validateEmail(email) &&
      validateDesignation(designation) &&
      validateWebsiteURL(websiteURL) &&
      validatePhone(phone) &&
      validateAnnualTurnover(annualTurnValue) &&
      validateGSTValue(gstValue) &&
      validateMessage(message) &&
      corporateEmailValidate;

    setIsFormValid(isValid);
    return isValid;
  }, [
    name,
    email,
    designation,
    websiteURL,
    phone,
    annualTurnValue,
    gstValue,
    message,
    corporateEmailValidate,
    hero3formFormFieldsCustomization,
  ]);

  useEffect(() => {
    setAnnualTurnoverYourself(...[annualTurnOverOptions]);
    setGstValueOption(...[gstValueOptions]);
  }, []);

  useEffect(() => {
    validateForm();
  }, [
    name,
    email,
    designation,
    websiteURL,
    phone,
    annualTurnValue,
    gstValue,
    message,
    corporateEmailValidate,
    validateForm,
  ]);

  const handleEmailChange = (e) => {
    const val = e.target.value;
    setEmail(val);
    setEmailValidate(!validateEmail(val));
  };

  const handleEmailBlur = (e) => {
    const val = e.target.value;
    if (doYouWantBusinessEmailRestrictionPaidads && validateEmail(val)) {
      checkCorporateEmail(val);
    }
  };

  const handleNameChange = (e) => {
    const val = e.target.value;
    setName(val);
    setNameValidate(!validateName(val));
  };

  const handleDesignationChange = (e) => {
    const val = e.target.value;
    setDesignation(val);
    setDesignationValidate(!validateDesignation(val));
  };

  const handleWebsiteURLChange = (e) => {
    const val = e.target.value;
    setWebsiteURL(val);
    setWebsiteURLValidate(!validateWebsiteURL(val));
  };

  const handlePhoneChange = (e) => {
    if (e.target.value >= 0) {
      const val = e.target.value.slice(0, 10);
      setPhone(val);
      setPhoneValidate(!validatePhone(val));
    }
  };

  const handleMessageChange = (e) => {
    const val = e.target.value;
    setMessage(val);
    setMessageValidate(!validateMessage(val));
  };

  const handleAnnualTurnoverChange = (val) => {
    setAnnualTurnOver(val);
    setAnnualTurnoverfValidation(!validateAnnualTurnover(val));
  };

  const handleGSTValueChange = (val) => {
    setGstValue(val);
    setGstValuevalidation(!validateGSTValue(val));
  };

  const extractQueryParams = (url) => {
    const queryParams = {};
    const queryString = url.split("?")[1];
    if (queryString) {
      queryString.split("&").forEach((param) => {
        const [key, value] = param.split("=");
        queryParams[key] = decodeURIComponent(value);
      });
    }
    return queryParams;
  };

  useEffect(() => {
    const queryParams = extractQueryParams(formUtmFormIntergration);
    const sourceActions = queryParams["source-action"];
    const actionTypes = queryParams["action"];
    setSourceAction(sourceActions);
    setActionType(actionTypes);
  }, [formUtmFormIntergration]);

  const dataObj = {
    action: "herosectionpage",
    name,
    email,
    phone,
    Turnover__c: annualTurnValue?.value,
    Designation__c: designation,
    website: websiteURL,
    role: chooseProductValue,
    No_of_Orders__c: gstValue?.value,
    message,
    source: sourceAction,
    cf_action_type: actionType,
    ...metadata,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataObj),
  };

  const submitData = () => {
    if (isFormValid) {
      fetch(`${MERCHANT_HELP_URL}`, requestOptions).then((response) => {
        if (!response.ok) {
          setOpenSuccessModal(false);
        } else {
          setOpenSuccessModal(true);
          setName("");
          setDesignation("");
          setWebsiteURL("");
          setAnnualTurnOver("");
          setGstValue("");
          setEmail("");
          setPhone("");
          setMessage("");

          setTimeout(() => {
            setOpenSuccessModal(false);
          }, 3000);
        }
        return response.json();
      });
    } else {
      // Set validation errors for empty fields
      setNameValidate(!validateName(name));
      setEmailValidate(!validateEmail(email));
      setDesignationValidate(!validateDesignation(designation));
      setWebsiteURLValidate(!validateWebsiteURL(websiteURL));
      setPhoneValidate(!validatePhone(phone));
      setAnnualTurnoverfValidation(!validateAnnualTurnover(annualTurnValue));
      setGstValuevalidation(!validateGSTValue(gstValue));
      setMessageValidate(!validateMessage(message));

      setShowFormError(true);
      setTimeout(() => {
        setShowFormError(false);
      }, 3000);
    }
  };

  return (
    <>
      <div className="flex rounded-md flex-col merchant-form md:!w-[100%] pt-[17px] md:pt-[20px] pb-[48px] md:pb-[16px] bg-white">
        <div className="md:px-[20px]">
          <div className="text-[20px] font-semibold mb-[15px] text-cf-primary flex justify-center">
            Talk to our expert now!
          </div>
          <div className="form-wrapper">
            <div className="text-sm font-semibold mb-3">
              {hero3formFormFieldsCustomization?.includes("Name") && (
                <div className="mb-[15px]">
                  <input
                    type="text"
                    id="name"
                    className={
                      nameValidate
                        ? "border-red-500 text-cf-hero border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                        : "border text-cf-hero text-2.5sm md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                    }
                    placeholder="Name*"
                    name="name"
                    autoComplete="off"
                    value={name}
                    onChange={handleNameChange}
                  />
                  {nameValidate && (
                    <p className="font-light text-cf-red-400">
                      Please enter your Name
                    </p>
                  )}
                </div>
              )}

              <span className="mb-[15px] md:flex md:justify-between">
                {hero3formFormFieldsCustomization?.includes("work_email") && (
                  <>
                    {doYouWantBusinessEmailRestrictionPaidads ? (
                      <div
                        className={`md:w-[47%] mb-[15px] md:mb-[0px]
                                       ${
                                         hero3formFormFieldsCustomization?.includes(
                                           "Designation",
                                         )
                                           ? "md:w-[47%]"
                                           : "md:w-full"
                                       }
                                       
                                       `}>
                        <input
                          type="email"
                          id="email"
                          className={
                            email.length < 1 && emailValidate
                              ? "border-red-500 text-cf-hero border text-2.5sm md:text-2sm  rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                              : "border text-cf-hero text-2.5sm md:text-2sm  rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                          }
                          placeholder="Work Email*"
                          name="email"
                          autoComplete="off"
                          value={email}
                          onBlur={handleEmailBlur}
                          onChange={handleEmailChange}
                        />
                        {emailValidate && (
                          <p className="font-light text-cf-red-400">
                            Please enter your Email
                          </p>
                        )}
                        {!corporateEmailValidate && (
                          <p className="font-light text-cf-red-400">
                            Please enter your business email address.
                          </p>
                        )}
                      </div>
                    ) : (
                      <div
                        className={`md:w-[47%] mb-[15px] md:mb-[0px]
                      ${
                        hero3formFormFieldsCustomization?.includes(
                          "Designation",
                        )
                          ? "md:w-[47%]"
                          : "md:w-full"
                      }
                      
                      `}>
                        <input
                          type="email"
                          id="email"
                          className={
                            email.length < 1 && emailValidate
                              ? "border-red-500 text-cf-hero border text-2.5sm md:text-2sm  rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                              : "border text-cf-hero text-2.5sm md:text-2sm  rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                          }
                          placeholder="Email*"
                          name="email"
                          autoComplete="off"
                          value={email}
                          onChange={handleEmailChange}
                        />
                        {emailValidate && (
                          <p className="font-light text-cf-red-400">
                            Please enter your Email
                          </p>
                        )}
                      </div>
                    )}
                  </>
                )}
                {hero3formFormFieldsCustomization?.includes("Designation") && (
                  <div
                    className={`md:w-[47%] mb-[15px] md:mb-[0px]
                                         ${
                                           hero3formFormFieldsCustomization?.includes(
                                             "work_email",
                                           )
                                             ? "md:w-[47%]"
                                             : "md:w-full"
                                         }
                                         
                                         `}>
                    <input
                      type="text"
                      id="designation"
                      className={
                        designationValidate
                          ? "border-red-500 text-cf-hero border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                          : "border text-2.5sm text-cf-hero md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                      }
                      placeholder="Designation*"
                      name="designation"
                      autoComplete="off"
                      value={designation}
                      onChange={handleDesignationChange}
                    />
                    {designationValidate && (
                      <p className="font-light text-cf-red-400">
                        Please enter your Designation
                      </p>
                    )}
                  </div>
                )}
              </span>
              <span className="mb-[15px] md:flex md:justify-between">
                {hero3formFormFieldsCustomization?.includes("website_URL") && (
                  <div
                    className={`md:w-[47%] mb-[15px] md:mb-[0px]
                        ${
                          hero3formFormFieldsCustomization?.includes(
                            "phone_number",
                          )
                            ? "md:w-[47%]"
                            : "md:w-full"
                        }
                        
                        `}>
                    <input
                      type="text"
                      id="websiteURL"
                      className={
                        websiteURLValidate
                          ? "border-red-500 border text-cf-hero text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                          : "border text-2.5sm text-cf-hero md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                      }
                      placeholder="Website URL*"
                      name="websiteURL"
                      autoComplete="off"
                      value={websiteURL}
                      onChange={handleWebsiteURLChange}
                    />
                    {websiteURLValidate && (
                      <p className="font-light text-cf-red-400">
                        Please enter your Website
                      </p>
                    )}
                  </div>
                )}
                {hero3formFormFieldsCustomization?.includes("phone_number") && (
                  <div
                    className={`md:w-[47%] mb-[15px] md:mb-[0px]
                  ${
                    hero3formFormFieldsCustomization?.includes("website_URL")
                      ? "md:w-[47%]"
                      : "md:w-full"
                  }
                  
                  `}>
                    <input
                      type="text"
                      id="phone"
                      className={
                        phoneValidate
                          ? "border-red-500 text-cf-hero border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                          : "border text-2.5sm text-cf-hero md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1"
                      }
                      placeholder="Phone*"
                      name="phone"
                      autoComplete="off"
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                    {phoneValidate && (
                      <p className="font-light text-cf-red-400">
                        Please enter your 10 digit Phone Number
                      </p>
                    )}
                  </div>
                )}
              </span>
              <span className="mb-[15px] md:flex md:justify-between">
                {hero3formFormFieldsCustomization?.includes(
                  "Annual_turnover",
                ) && (
                  <div
                    className={`text-cf-hero mb-[15px] md:mb-[0px] ${
                      hero3formFormFieldsCustomization.includes("Gst_Yes_No")
                        ? " md:w-[47%]"
                        : "md:w-[100%]"
                    }`}>
                    <Select
                      className={
                        annualTurnoverValidation
                          ? "border-red-500 border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full mt-1"
                          : " text-2.5sm md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full mt-1"
                      }
                      id="describe_yourself"
                      placeholder="Annual Turnover*"
                      options={annualTurnover}
                      onChange={handleAnnualTurnoverChange}
                      selectedOption={annualTurnValue}
                    />
                    {annualTurnoverValidation && (
                      <p className="font-light text-cf-red-400">
                        Please select the Turnover
                      </p>
                    )}
                  </div>
                )}

                {hero3formFormFieldsCustomization?.includes("Gst_Yes_No") && (
                  <div
                    className={`text-cf-hero mb-[15px] md:mb-[0px] ${
                      hero3formFormFieldsCustomization.includes(
                        "Annual_turnover",
                      )
                        ? " md:w-[47%]"
                        : "md:w-[100%]"
                    }`}>
                    <Select
                      className={
                        gstValueValidation
                          ? "border-red-500 border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full mt-1"
                          : " text-2.5sm md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full mt-1"
                      }
                      id="describe_yourself"
                      placeholder="GST (Yes/No)*"
                      options={gstValueOption}
                      onChange={handleGSTValueChange}
                      selectedOption={gstValue}
                    />
                    {gstValueValidation && (
                      <p className="font-light text-cf-red-400">
                        Please select the GST
                      </p>
                    )}
                  </div>
                )}
              </span>
              {hero3formFormFieldsCustomization.includes("Message") && (
                <div className="mb-[24px] text-cf-hero">
                  <textarea
                    id="message"
                    rows="4"
                    className={
                      messageValidate
                        ? "border-red-500 border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 font-light mt-1"
                        : "border text-2.5sm md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 font-light mt-1"
                    }
                    placeholder="Anything else? (Tell us about your business, specific needs & timelines)*"
                    name="message"
                    value={message}
                    onChange={handleMessageChange}
                  />
                  {messageValidate && (
                    <p className="font-light text-cf-red-400">
                      Please tell us something about yourself
                    </p>
                  )}
                </div>
              )}
              <button
                type="submit"
                onClick={submitData}
                disabled={!isFormValid}
                className={`button ${
                  isFormValid
                    ? "bg-cf-green"
                    : "bg-cf-green opacity-50 !cursor-not-allowed"
                } button-green inline-block md:mb-0 w-full md:w-full text-white`}>
                Submit <span className="chevron" />
              </button>
              <br />
            </div>
            {openSuccessModal ? (
              <div className="text-[#240253] flex bg-[#05C16E2E] p-5 rounded-md mt-[34px]">
                <Image
                  src="https://cashfreelogo.cashfree.com/website/landings/assets/report_tick.svg"
                  alt="success-modal"
                  className="pr-[8px]"
                  width="40"
                  height="40"
                />
                We have received your request. Our support team will get in
                touch with you within 12 working hours.
              </div>
            ) : (
              <>
                {showFormError ? (
                  <div className="mt-3 text-cf-red-400">
                    Please fill the form completely
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

HeroSectionForm.defaultProps = {
  formUtmFormIntergration: "",
  chooseProductValue: "",
  doYouWantBusinessEmailRestrictionPaidads: false,
  hero3formFormFieldsCustomization: [],
};

HeroSectionForm.propTypes = {
  formUtmFormIntergration: PropTypes.string,
  chooseProductValue: PropTypes.string,
  doYouWantBusinessEmailRestrictionPaidads: PropTypes.bool,
  hero3formFormFieldsCustomization: PropTypes.arrayOf(PropTypes.string),
};

export default HeroSectionForm;
